import { useState, useContext } from "react";
import { GlobalContext } from "../../Context/GlobalContext";
import { toast } from "react-toastify";

const useMedia = () => {
  const { api, userID } = useContext(GlobalContext);

  const [mediaList, setMediaList] = useState([]);
  const [loadingMedia, setLoadingMedia] = useState(false);

  const fetchUploadedMedia = async () => {
    setLoadingMedia(true);

    try {
      const res = await api.post("/Whatsapp/getUploadedMedia", {
        userid: userID,
        offset: "100",
        page: "1",
      });

      const data = res.data;

      if (data.responseCode === "00") {
        setMediaList(data.data || []);
      } else {
        toast.error(data.responseMessage || "Failed to load media");
      }

      return data;
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
      return null;
    } finally {
      setLoadingMedia(false);
    }
  };

  const sendMedia = async (payload) => {
    try {
      const res = await api.post("/Whatsapp/sendMedia", {
        userid: userID,
        ...payload,
      });

      const data = res.data;

      if (data.responseCode === "00") {
        toast.success(data.responseMessage || "Media sent successfully");
      } else {
        toast.error(data.responseMessage || "Failed to send media");
      }

      return data;
    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
      return null;
    }
  };

  return {
    mediaList,
    loadingMedia,
    fetchUploadedMedia,
    sendMedia,
  };
};

export default useMedia;